export default function storeInstitutionData(value) {

    return dispatch => dispatch({
        type: 'SAVE_INSTITUTIONDATA_FULFILLED',
        payload: value
    });
}


// WEBPACK FOOTER //
// ./src/actions/VXC/storeInstitutionData.js